import React, { useRef, useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebaseModel';
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react-lite";
import SignupView from '../views/signupView';

const SignupPresenter = (props) => {
    const navigate = useNavigate();
    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);
    const usernameRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(null); 
    const back = () => {
        navigate("/");
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        const email = emailRef.current.value;
        const password = passwordRef.current.value;


        if (password !== confirmPasswordRef.current.value) {
            setErrorMessage("     Passwords do not match"); 
            return;
        }

        props.model.setUsername(usernameRef.current.value);

        await createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                navigate("/home");
            })
            .catch((error) => {
                var errorCode = error.code;
                errorCode = errorCode.slice(5).replace(/-/g, ' ');
                if (errorCode.includes("password")) {
                    errorCode += " - minimum length of 6 characters";
                }
                setErrorMessage(errorCode); 
            });
    }

    const Signup = observer(
        function SignupRender(props){
            return <SignupView
                emailRef={emailRef}
                passwordRef={passwordRef}
                confirmPasswordRef={confirmPasswordRef}
                usernameRef={usernameRef}
                onSubmit={onSubmit}
                errorMessage={errorMessage} // Pass error message to SignupView
                back={back}
            />;
        }
    );

    return <Signup />;
};

export default SignupPresenter;
